import { render, staticRenderFns } from "./RequirementSettings.vue?vue&type=template&id=530aebd1"
import script from "./RequirementSettings.vue?vue&type=script&lang=ts"
export * from "./RequirementSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530aebd1')) {
      api.createRecord('530aebd1', component.options)
    } else {
      api.reload('530aebd1', component.options)
    }
    module.hot.accept("./RequirementSettings.vue?vue&type=template&id=530aebd1", function () {
      api.rerender('530aebd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/RequirementSettings.vue"
export default component.exports